import React, { useRef } from 'react'
import PrimaryTitle from '../../../../components/PrimaryTitle'
import { inject, observer } from 'mobx-react'
import { Input, DateInput, CustomSelect } from '../../../../components/formComponents'
import { Form, Button } from 'react-bootstrap'
import DocumentStore from '../../../../store/documentForm.store'
import PropTypes from 'prop-types'
import t from '../../../../service/translate.service'
import ContractSelector from '../../../../components/contractSelector'
import { buildValidators } from '../../../../service/validate'
import { Alert } from 'antd'
import { useNavigate } from 'react-router-dom'

const KeepAnimals = (props) => {
  const inputRefs = useRef({})
  const { model, setVal, keepAnimalValidators, keepAnimalValidatorInputs, errorsList, errorListVoice, submitted } = DocumentStore
  const { file } = props
  const validatorBlur = buildValidators(keepAnimalValidatorInputs, true)
  const navigate = useNavigate()

  const generateErrorList = () => {
    const errors = []
    for (let key in inputRefs?.current) {
      const item = inputRefs?.current[key]
      if (key === 'date') {
        if (validatorBlur[key] && validatorBlur[key](item?.props?.selected, item?.props['aria-label'])) {
          let err = validatorBlur[key](item?.props?.selected, item?.props['aria-label'])
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.setFocus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      } else {
        if (item && validatorBlur[key] && validatorBlur[key](item?.value, item?.ariaLabel)) {

          let err = validatorBlur[key](item.value, item.ariaLabel)
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.focus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      }       
    }
    return errors
  }
  const onSubmit = async (e) => {
    e.preventDefault()
    DocumentStore.submit(file.fileName, props.contractStore.selectedContract.contractNumber, generateErrorList)
  }
  const getAttrs = field => {
    return {
      value: model[field],
      onChange: e => setVal(field, e.target.value),
      validate: keepAnimalValidators[field],
      blurValidate: validatorBlur[field]
    }
  }
  const AlertContent = () => {
    if (errorsList?.length > 0) {
      if (props?.documentFormHolderRef) {
        props.documentFormHolderRef?.current?.scrollTo(0,0)
      }
      return (
        <Alert
          role={errorListVoice ? "alert" : "none"}
          message={
            <div
              className='error-list'
              role={errorListVoice ? "alert" : "none"}
              aria-live={errorListVoice ? "assertive" : "off"}
            >
              {t.REQUIRED_FIELD_MISSING}
              {errorsList?.map((err) => {
                return err
              })}
            </div>
          }
          type='error'
          style={{ marginTop: '12px', marginBottom: '12px' }}
        />
      )
    } else {
      return (<></>)
    }
  }

  return (
    <div className='form-holder'>
      <PrimaryTitle title={t.KEEP_ANIMALS} />
      {submitted && (
        <AlertContent />
      )}
      <Form>
        <ContractSelector required={true} label padding page='documents' aria-label={t.SELECT_CONTRACT} />
        <h3 className='inputs-text'>{t.KEEP_ANIMALS_HEAD_ONE}</h3>
  
        <Input
          ref={(el) => (inputRefs.current['keepAnimalSpecie'] = el)}
          name='keepAnimalSpecie'
          {...getAttrs('keepAnimalSpecie')}
          label={t.DIGITAL_CONTRACT_FORM_ANIMAL_SPECIES + '*'}
          aria-label={t.ANIMAL_SPECIES}
        />
  
        <Input
          ref={(el) => (inputRefs.current['keepAnimalRace'] = el)}
          name='keepAnimalRace'
          {...getAttrs('keepAnimalRace')}
          label={t.DIGITAL_CONTRACT_FORM_RACE + '*'}
          aria-label={t.RACE}
        />
  
        <Input
          ref={(el) => (inputRefs.current['keepAnimalDescription'] = el)}
          name='keepAnimalDescription'
          {...getAttrs('keepAnimalDescription')}
          label={t.DIGITAL_CONTRACT_DESCRIPTION_WEIGHT + '*'}
          aria-label={t.DESCRIPTION_WEIGHT}
        />
        
        <p className='inputs-text'>{t.KEEP_ANIMALS_PARA_ONE}</p>
        <Input ref={(el) => (inputRefs.current['keepAnimalQuantity'] = el)} name='keepAnimalQuantity' {...getAttrs('keepAnimalQuantity')} label={t.DIGITAL_CONTRACT_DESCRIPTION_QUANTITY + '*'} aria-label={t.ANIMAL_QUANTITY} />
        <CustomSelect styles={{ width: '100%', maxWidth: '150px' }} onChange={(option) => {
          setVal('keepAnimalOwnPet', option.value)
          setVal('keepAnimalType', '')
          setVal('keepAnimalNumber', '')
        }} options={[{ value: t['LOGOUT_YES'], label: t['LOGOUT_YES'] }, { value: t['LOGOUT_NO'], label: t['LOGOUT_NO'] }]} defaultValue={{ value: t['LOGOUT_NO'], label: t['LOGOUT_NO'] }} label={t.DIGITAL_CONTRACT_DESCRIPTION_ALREADY_OWN_PET} aria-label={t.ALREADY_OWN_PET} />
        {model['keepAnimalOwnPet'] === t['LOGOUT_YES'] && (
          <div className='more-inputs-holder'>
            <Input
              ref={(el) => (inputRefs.current['keepAnimalType'] = el)}
              name='keepAnimalType'
              {...getAttrs('keepAnimalType')}
              label={t.DIGITAL_CONTRACT_ANIMAL_TYPE + '*'}
              aria-label={t.ANIMAL_TYPE}
            />
            <Input
              ref={(el) => (inputRefs.current['keepAnimalNumber'] = el)}
              name='keepAnimalNumber'
              {...getAttrs('keepAnimalNumber')}
              label={t.DIGITAL_CONTRACT_ANIMAL_NUMBER + '*'}
              aria-label={t.ANIMAL_NUMBER}
            />
          </div>
        )}
  
        <p className='input-para'>{t.KEEP_ANIMALS_PARA_TWO}</p>
        <Input ref={(el) => (inputRefs.current['place'] = el)} autoComplete="address-level2" name='place' {...getAttrs('place')} label={t.DIGITAL_CONTRACT_FORM_PLACE + '*'} aria-label={t.PLACE} />
        <DateInput blurValidate={validatorBlur['date']} ref={(el) => (inputRefs.current['date'] = el)} name='date' value={model['date']} onChange={(date) => setVal('pate', date)} validate={keepAnimalValidators['date']} label={t.DIGITAL_CONTRACT_FORM_DATE + '*'} aria-label={t.DATE} />
        <Form.Group className='actions text-center'>
          <div className='group'>
            <button
              className='button primary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                onSubmit(e)
              }}
              aria-label={t.SUBMIT_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_SEND}
            </button>
            <a
              href='/documents'
              className='button secondary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                DocumentStore.onCloseForm()
                navigate('/documents')
              }}
              style={{
                textDecoration: 'none',
                color: 'unset'
              }}
              aria-label={t.CANCEL_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_CANCEL}
            </a>
          </div>
        </Form.Group>
      </Form>
    </div>
  );
}

KeepAnimals.propTypes = {
  file: PropTypes.object.isRequired,
  contractStore: PropTypes.object
}

export default inject('contractStore')(observer(KeepAnimals))
